import { gql } from '@apollo/client';
export const StatFeatureStaffRatioV2 = gql `
    fragment StatFeatureStaffRatioV2 on StaffRatioV2FeatureSettings {
        isEnabled
    }
`;
